import { SVGProps } from 'react'

export const ArrowDropdown = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24" {...props}>
    <path fill="currentColor" d="M7 9.5l5 5 5-5H7z"></path>
  </svg>
)
